import React, { useState } from "react";
import { Container, Row, Alert, Button } from "react-bootstrap";
import Papa from "papaparse";
import HelperMetiers360 from "../../../services/HelpersMetiers360";

import MultiClientInfoComponent from '../multiClient/MultiClientInfoComponent';
import CheckMultiClientComponent from "./CheckMultiClientComponent";
import SelectCSVDataComponent from "../../widgets/selectCSVData/SelectCSVDataComponent";
import SummaryTableComponent from "./SummaryTableComponent";

const GetMultiClientComponent = (props) => {
    const { clientsRef, onValidate, clientsParent, dataStructureTarget, clientsCategories } = props;

    const [stage, setStage] = useState(0);
    const [csvContent, setCsvContent] = useState(null);
    const [rowChoosen, setRowChoosen] = useState(false);
    const [dataStructure, setDataStructure] = useState(dataStructureTarget.map((data) => {return {...data}}));
    const [clientsInfos, setClientsInfos] = useState(false);
    const [subscription, setSubscription] = useState(false);


    const changeHandler = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        // Decode the file ourselves to support both UTF-8 and windows-1252 (Excel on Windows)
        const text = HelperMetiers360.decodeCsvBuffer(await file.arrayBuffer());
        Papa.parse(text, {
            header: true,
            skipEmptyLines: true,
            complete: function (results) {
                // Remove empty lines in csv
                results.data = results.data.filter(d => !Object.values(d).every(v => v === ""));
                setCsvContent(results);
            },
        });

        setStage(1);
    };

    const checkPhase = () => {
        clientsRef.current = csvContent.data
            .map(row => dataStructure.reduce((acc,data) => {
                    acc[data.field] = row[data.csvIdx];
                    if(data.callBack) {acc[data.field]=data.callBack(acc[data.field])}
                    return acc;
                },{})
            );
        setStage(2);
    }


    const onValidateLastStep = (clientsInfosFormData, subscriptionFormData) => {
        setClientsInfos(clientsInfosFormData);
        setSubscription(subscriptionFormData);
    }

    const checkDataButton = <Button variant="primary" size="sm" className="align-right" 
            disabled={!rowChoosen} onClick={checkPhase}>
            Phase suivante <span className="icon-arrow-right"></span>
        </Button>;
    
    const stage0 = <Container>
            <Row>
            <Alert variant="info"><MultiClientInfoComponent client={clientsParent} /></Alert>
            </Row>
            <Row>
                <div className="custom-file">
                    <input
                        type="file"
                        name="file"
                        className="custom-file-input"
                        accept=".csv"
                        onChange={changeHandler}
                    />
                    <label className="custom-file-label" htmlFor="inputGroupFile01" data-browse="Parcourir">
                        Choisir un fichier csv
                    </label>
                </div>
            </Row>
        </Container>;

    const stage1 = <Container>
                <Button variant="primary" size="sm" className="mb-3" onClick={() => setStage(0)}>
                    <span className="icon-arrow-left"></span> Phase précédente
                </Button>
            <Row>
                <SelectCSVDataComponent 
                    csvContent={csvContent} 
                    dataStructure={dataStructure} 
                    setDataStructure={setDataStructure} 
                    fieldsNecessary={["name", "categories", "addressStreet", "addressZipCode", "addressCity"]}
                    setRowChoosen={setRowChoosen} />
            </Row>
            {checkDataButton}
        </Container>;

    const stage2 = <CheckMultiClientComponent 
        clients={clientsRef.current} 
        dataStructure = {dataStructure}
        clientsParent={clientsParent}
        clientsCategories={clientsCategories}
        onValidateStep={onValidateLastStep}
        onCancel={() => setStage(1)}
        nextStage={() => setStage(3)}
    />

    const stage3 = <SummaryTableComponent
        clients={clientsRef.current}
        clientsCommonInfos={clientsInfos}
        subscription={subscription}
        dataStructure={dataStructure}
        onValidate={onValidate}
        clientsCategories={clientsCategories}
        onCancel={() => setStage(2)}
    />


    const display = [stage0, stage1, stage2, stage3];

    return <>{display[stage]}</>
}

export default GetMultiClientComponent;